import { render, staticRenderFns } from "./GraduateTips.vue?vue&type=template&id=391b5d4c&scoped=true"
import script from "./GraduateTips.vue?vue&type=script&lang=js"
export * from "./GraduateTips.vue?vue&type=script&lang=js"
import style0 from "./GraduateTips.vue?vue&type=style&index=0&id=391b5d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b5d4c",
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImgLazy} from 'bootstrap-vue'
    installComponents(component, {BImgLazy})
    

export default component.exports